import { render, staticRenderFns } from "./GiftMessageListBadgeMake.vue?vue&type=template&id=6fcbea90&scoped=true"
import script from "./GiftMessageListBadgeMake.vue?vue&type=script&lang=js"
export * from "./GiftMessageListBadgeMake.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcbea90",
  null
  
)

export default component.exports